import { DefectSummaryDataItem } from "../../types/DefectSummaryDataItem";
import { DefectPriority } from "../../types/DefectPriority";
import { sendGAEvent } from "../../AnalyticsService";
import { 
    DEFECTS_SUMMARY,
    DEFECTS_SUMMARY_HIGH_PRIORITY_CLICK,
    DEFECTS_SUMMARY_MEDIUM_PRIORITY_CLICK,
    DEFECTS_SUMMARY_LOW_PRIORITY_CLICK,
 } from "../../constants/analytics";
import { FilterMatchMode } from "primereact/api";
import { classNames } from "primereact/utils";
import { useAppDispatch } from "../../hooks/storeHooks";
import { setActiveTab } from "../../store/slices/defectSlice";
import { resetTableFilters } from "../../store/thunks/filtersThunks";
import { getSummaryTableLinkConfig } from "../../utils/DefectsSummaryTableDataHelper";

type SharedDefectSummaryPriorityLinkProps = {
    rowData: DefectSummaryDataItem;
    priority: DefectPriority;
}

export const SharedDefectSummaryPriorityLink = (props: SharedDefectSummaryPriorityLinkProps) => {
    const { rowData, priority } = props;
    const dispatch = useAppDispatch();

    let value = rowData.highPriorityCount;
    let icon = "/high.svg";
    let gaEvent = DEFECTS_SUMMARY_HIGH_PRIORITY_CLICK;

    if (priority === DefectPriority.medium) {
        value = rowData.mediumPriorityCount;
        icon = "/medium.svg";
        gaEvent = DEFECTS_SUMMARY_MEDIUM_PRIORITY_CLICK;
    }

    if (priority === DefectPriority.low) {
        value = rowData.lowPriorityCount;
        icon = "/low.svg";
        gaEvent = DEFECTS_SUMMARY_LOW_PRIORITY_CLICK;
    }

    const { tableKey, defaultConfig, nameField, statusField, priorityField } = getSummaryTableLinkConfig(true);

    const navigateToDefectsTab = () => {
        if (value) {        
            dispatch(resetTableFilters(tableKey, { 
                ...defaultConfig,
                [nameField]: { value: rowData.vesselName },
                [statusField]: { value: [], matchMode: FilterMatchMode.IN },
                [priorityField]: { value: [priority], matchMode: FilterMatchMode.IN },
            }));
            dispatch(setActiveTab(1));
            sendGAEvent(DEFECTS_SUMMARY, gaEvent);
        }
    }

    return (
        <button 
            className={classNames("font-semibold defect-priority-link-btn", value ? "cursor-pointer read-more-btn underline" : null)}
            onClick={navigateToDefectsTab}
        >
            <div className="mr-3">
                <img src={icon} className="priority-icon-size-small" alt={`priority-icon-${priority}`} />
            </div>
            {value}
        </button>
    )
};
